import { ICellRendererParams } from '@ag-grid-community/core';

import './BtnCopyRenderer.css';

const BtnCopyRenderer = (props: ICellRendererParams) => {
    return (
      <img src="images/duplicate.svg" className="grid_copy_btn" alt="copy button" />
    );
  };
 
export default BtnCopyRenderer;